import { useMap } from 'ms-map-gl'
import { useEffect, useCallback, useMemo } from 'react'
import { useBounds } from '~map-preview/states/map'

export const useSetFitBounds = () => {
  const { default: map } = useMap()
  const bounds = useBounds()

  const setFitBounds = useCallback(
    (boundData) => {
      const hasBounds = boundData?.length === 4

      if (!map || !hasBounds) return

      map.fitBounds(boundData, {
        duration: 1500,
        padding: 20
      })
    },
    [map]
  )

  // INFO: Handle fit bounds change
  useEffect(() => {
    setFitBounds(bounds)
  }, [setFitBounds, map, bounds])

  // INFO: Handle browser resize
  useEffect(() => {
    const handleResize = () => {
      setFitBounds(bounds)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [bounds, setFitBounds, map])
}
